import React from 'react'

const EmptyScreen = ({
    children,
}: {
    children?: React.ReactNode;
}) => {
    return (
        <div className="absolute inset-0 flex items-center justify-center heading6">
            {children}
        </div>

    );
};

export default EmptyScreen